import { render } from "./VerGrupos.vue?vue&type=template&id=1da97c60"
import script from "./VerGrupos.vue?vue&type=script&lang=js"
export * from "./VerGrupos.vue?vue&type=script&lang=js"

import "./VerGrupos.vue?vue&type=style&index=0&id=1da97c60&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__